module.exports = __webpack_public_path__ + "media/images/ic_database-228a969d333faa05dc1cf935bc55a886.svg";